// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-stepper-item {
  align-items: center;
  align-self: stretch;
  display: inline-flex;
  flex: none;
  outline: none;
  opacity: var(--v-medium-emphasis-opacity);
  padding: 1.5rem;
  position: relative;
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
:where(.vuetify-styles) .v-stepper-item:hover > .v-stepper-item__overlay {
  opacity: calc(var(--v-hover-opacity) * var(--v-theme-overlay-multiplier));
}
:where(.vuetify-styles) .v-stepper-item:focus-visible > .v-stepper-item__overlay {
  opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));
}
@supports not selector(:focus-visible) {
  :where(.vuetify-styles) .v-stepper-item:focus > .v-stepper-item__overlay {
    opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));
  }
}
:where(.vuetify-styles) .v-stepper-item--active > .v-stepper-item__overlay, :where(.vuetify-styles) .v-stepper-item[aria-haspopup=menu][aria-expanded=true] > .v-stepper-item__overlay {
  opacity: calc(var(--v-activated-opacity) * var(--v-theme-overlay-multiplier));
}
:where(.vuetify-styles) .v-stepper-item--active:hover > .v-stepper-item__overlay, :where(.vuetify-styles) .v-stepper-item[aria-haspopup=menu][aria-expanded=true]:hover > .v-stepper-item__overlay {
  opacity: calc((var(--v-activated-opacity) + var(--v-hover-opacity)) * var(--v-theme-overlay-multiplier));
}
:where(.vuetify-styles) .v-stepper-item--active:focus-visible > .v-stepper-item__overlay, :where(.vuetify-styles) .v-stepper-item[aria-haspopup=menu][aria-expanded=true]:focus-visible > .v-stepper-item__overlay {
  opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));
}
@supports not selector(:focus-visible) {
  :where(.vuetify-styles) .v-stepper-item--active:focus > .v-stepper-item__overlay, :where(.vuetify-styles) .v-stepper-item[aria-haspopup=menu][aria-expanded=true]:focus > .v-stepper-item__overlay {
    opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));
  }
}
:where(.vuetify-styles) .v-stepper--non-linear .v-stepper-item {
  opacity: var(--v-high-emphasis-opacity);
}
:where(.vuetify-styles) .v-stepper-item--selected {
  opacity: 1;
}
:where(.vuetify-styles) .v-stepper-item--error {
  color: rgb(var(--v-theme-error));
}
:where(.vuetify-styles) .v-stepper-item--disabled {
  opacity: var(--v-medium-emphasis-opacity);
}
:where(.vuetify-styles) .v-stepper-item[disabled], :where(.vuetify-styles) .v-stepper-item--disabled {
  pointer-events: none;
}
:where(.vuetify-styles) .v-stepper--alt-labels .v-stepper-item {
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-basis: 175px;
}

:where(.vuetify-styles) .v-stepper-item__avatar.v-avatar {
  background: rgba(var(--v-theme-surface-variant), var(--v-medium-emphasis-opacity));
  color: rgb(var(--v-theme-on-surface-variant));
  font-size: 0.75rem;
  margin-inline-end: 8px;
}
:where(.vuetify-styles) .v-stepper--mobile .v-stepper-item__avatar.v-avatar {
  margin-inline-end: 0;
}
:where(.vuetify-styles) .v-stepper-item__avatar.v-avatar .v-icon {
  font-size: 0.875rem;
}
:where(.vuetify-styles) .v-stepper-item--selected .v-stepper-item__avatar.v-avatar, :where(.vuetify-styles) .v-stepper-item--complete .v-stepper-item__avatar.v-avatar {
  background: rgb(var(--v-theme-surface-variant));
}
:where(.vuetify-styles) .v-stepper-item--error .v-stepper-item__avatar.v-avatar {
  background: rgb(var(--v-theme-error));
}
:where(.vuetify-styles) .v-stepper--alt-labels .v-stepper-item__avatar.v-avatar {
  margin-bottom: 16px;
  margin-inline-end: 0;
}

:where(.vuetify-styles) .v-stepper-item__content {
  text-align: start;
}
:where(.vuetify-styles) .v-stepper--alt-labels .v-stepper-item__content {
  text-align: center;
}

:where(.vuetify-styles) .v-stepper-item__title {
  line-height: 1;
}
:where(.vuetify-styles) .v-stepper--mobile .v-stepper-item__title {
  display: none;
}

:where(.vuetify-styles) .v-stepper-item__subtitle {
  font-size: 0.75rem;
  line-height: 1;
  opacity: var(--v-medium-emphasis-opacity);
}
:where(.vuetify-styles) .v-stepper--mobile .v-stepper-item__subtitle {
  display: none;
}

:where(.vuetify-styles) .v-stepper-item__overlay {
  background-color: currentColor;
  border-radius: inherit;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

:where(.vuetify-styles) .v-stepper-item__overlay,
:where(.vuetify-styles) .v-stepper-item__underlay {
  pointer-events: none;
}
:where(.vuetify-styles) .v-stepper-item__overlay,
:where(.vuetify-styles) .v-stepper-item__underlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VStepper/VStepperItem.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,aAAa;EACb,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,wDAAwD;AAC1D;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,yEAAyE;AAC3E;AACA;EACE;IACE,yEAAyE;EAC3E;AACF;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,wGAAwG;AAC1G;AACA;EACE,wGAAwG;AAC1G;AACA;EACE;IACE,wGAAwG;EAC1G;AACF;AACA;EACE,uCAAuC;AACzC;AACA;EACE,UAAU;AACZ;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kFAAkF;EAClF,6CAA6C;EAC7C,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,+CAA+C;AACjD;AACA;EACE,qCAAqC;AACvC;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,UAAU;EACV,oCAAoC;AACtC;;AAEA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd","sourcesContent":[".v-stepper-item {\n  align-items: center;\n  align-self: stretch;\n  display: inline-flex;\n  flex: none;\n  outline: none;\n  opacity: var(--v-medium-emphasis-opacity);\n  padding: 1.5rem;\n  position: relative;\n  transition-duration: 0.2s;\n  transition-property: opacity;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-stepper-item:hover > .v-stepper-item__overlay {\n  opacity: calc(var(--v-hover-opacity) * var(--v-theme-overlay-multiplier));\n}\n.v-stepper-item:focus-visible > .v-stepper-item__overlay {\n  opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));\n}\n@supports not selector(:focus-visible) {\n  .v-stepper-item:focus > .v-stepper-item__overlay {\n    opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));\n  }\n}\n.v-stepper-item--active > .v-stepper-item__overlay, .v-stepper-item[aria-haspopup=menu][aria-expanded=true] > .v-stepper-item__overlay {\n  opacity: calc(var(--v-activated-opacity) * var(--v-theme-overlay-multiplier));\n}\n.v-stepper-item--active:hover > .v-stepper-item__overlay, .v-stepper-item[aria-haspopup=menu][aria-expanded=true]:hover > .v-stepper-item__overlay {\n  opacity: calc((var(--v-activated-opacity) + var(--v-hover-opacity)) * var(--v-theme-overlay-multiplier));\n}\n.v-stepper-item--active:focus-visible > .v-stepper-item__overlay, .v-stepper-item[aria-haspopup=menu][aria-expanded=true]:focus-visible > .v-stepper-item__overlay {\n  opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));\n}\n@supports not selector(:focus-visible) {\n  .v-stepper-item--active:focus > .v-stepper-item__overlay, .v-stepper-item[aria-haspopup=menu][aria-expanded=true]:focus > .v-stepper-item__overlay {\n    opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));\n  }\n}\n.v-stepper--non-linear .v-stepper-item {\n  opacity: var(--v-high-emphasis-opacity);\n}\n.v-stepper-item--selected {\n  opacity: 1;\n}\n.v-stepper-item--error {\n  color: rgb(var(--v-theme-error));\n}\n.v-stepper-item--disabled {\n  opacity: var(--v-medium-emphasis-opacity);\n}\n.v-stepper-item[disabled], .v-stepper-item--disabled {\n  pointer-events: none;\n}\n.v-stepper--alt-labels .v-stepper-item {\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  flex-basis: 175px;\n}\n\n.v-stepper-item__avatar.v-avatar {\n  background: rgba(var(--v-theme-surface-variant), var(--v-medium-emphasis-opacity));\n  color: rgb(var(--v-theme-on-surface-variant));\n  font-size: 0.75rem;\n  margin-inline-end: 8px;\n}\n.v-stepper--mobile .v-stepper-item__avatar.v-avatar {\n  margin-inline-end: 0;\n}\n.v-stepper-item__avatar.v-avatar .v-icon {\n  font-size: 0.875rem;\n}\n.v-stepper-item--selected .v-stepper-item__avatar.v-avatar, .v-stepper-item--complete .v-stepper-item__avatar.v-avatar {\n  background: rgb(var(--v-theme-surface-variant));\n}\n.v-stepper-item--error .v-stepper-item__avatar.v-avatar {\n  background: rgb(var(--v-theme-error));\n}\n.v-stepper--alt-labels .v-stepper-item__avatar.v-avatar {\n  margin-bottom: 16px;\n  margin-inline-end: 0;\n}\n\n.v-stepper-item__content {\n  text-align: start;\n}\n.v-stepper--alt-labels .v-stepper-item__content {\n  text-align: center;\n}\n\n.v-stepper-item__title {\n  line-height: 1;\n}\n.v-stepper--mobile .v-stepper-item__title {\n  display: none;\n}\n\n.v-stepper-item__subtitle {\n  font-size: 0.75rem;\n  line-height: 1;\n  opacity: var(--v-medium-emphasis-opacity);\n}\n.v-stepper--mobile .v-stepper-item__subtitle {\n  display: none;\n}\n\n.v-stepper-item__overlay {\n  background-color: currentColor;\n  border-radius: inherit;\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out;\n}\n\n.v-stepper-item__overlay,\n.v-stepper-item__underlay {\n  pointer-events: none;\n}\n.v-stepper-item__overlay,\n.v-stepper-item__underlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
